<?php

\Core\View::$template = function () {

    $html = '<div class="container"><div class="row">';  
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);
    $rqd = $pv['request_data'];

    foreach ($rqd['items'] as $each_item) { 
        $html = $html .
            '    <div class="col-sm-6 col-12">
                    <div class="row">
                        <div class="col-sm-1 ">
                            &nbsp;
                        </div>
                        <div class="col-sm-12 ">
                            <div class="one_item single_interview_wrap">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <h5 class="item_id_title interview_title_top">Interview Video ID: ' . $each_item['id'] . '</h5>
                                        </div>
                                        <div class="col-sm-12">
                                            <h3 class="item_title interview_title"><a title="Click to open video" target="_blank" href="'. $each_item['url'] .'" class="item_url">' . $each_item['upload_title'] . '</a></h3>
                                        </div>
                                        <div class="col-sm-12">
                                            <h3 class="item_description interview_des">' . $each_item['upload_description'] . '</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            &nbsp;
                        </div>
                    </div>
                 </div>';
    }
    

    return $html.'</div></div>';

};


// WEBPACK FOOTER //
// app/UserAccount/View/UserAccountInterviews.php